export enum ActsGridView {
	FULL,
	UNPAID,
}
